import React from 'react';
//import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import AppTheme from './AppTheme';

function NewDemo() {  
    const { viewid } = useParams();
    const location = viewid;
    const lastPart = location.split('-').pop();
    let clientName = '';
    let activeTheme = '';
    let ThemeList = '';let listLanguage = '';let brandColor = '';let seasonBrand = '';let SeasonList='';let CustomFont='';  

  if (lastPart) {
  if (lastPart.charAt(0) === '1') {
      clientName = 'apparel';
      seasonBrand = 'brand_christmas,brand_newyear,brand_diwali,brand_thanks,brand_blackfriday,brand_ads';
      ThemeList = 'yellow,blue,red,Xmaroon,Xblack,Xgray,printer';
      SeasonList = 'brand_christmas,brand_newyear,brand_diwali,brand_thanks,brand_blackfriday,brand_ads';
      listLanguage='English,Arabic,French,Hindi'
  } else if (lastPart.charAt(0) === '2') {
      clientName = 'deichmann'; 
      activeTheme = 'green'; 
      brandColor = 'green';
      seasonBrand = 'brand_blackfriday,brand_ads';
      ThemeList = 'green,Xblack,Xgray,printer';
      SeasonList = 'brand_christmas,brand_newyear,brand_blackfriday,brand_thanks,brand_diwali,brand_ads';
      listLanguage = 'English,German';      
  }
  else if (lastPart.charAt(0) === '3') {
      clientName = 'hm';
      activeTheme = 'red';
      brandColor = 'red';
      seasonBrand = 'brand_blackfriday,brand_ads';
      ThemeList = 'red,black,gray,printer';
      SeasonList = 'brand_christmas,brand_newyear,brand_blackfriday,brand_thanks,brand_diwali,brand_ads';
      listLanguage = 'English';
      CustomFont='hm';      
  }
  else if (lastPart.charAt(0) === '4') {
      clientName = 'lego';
      activeTheme = 'lego';
      brandColor = 'lego';
      seasonBrand = 'brand_blackfriday,brand_ads';
      ThemeList = 'lego,yellow,red,xblue,xmaroon,xblack,xgray,xpink,printer';
      SeasonList = 'brand_christmas,brand_newyear,brand_blackfriday,brand_thanks,brand_diwali,brand_ads';
      listLanguage = 'English';
      CustomFont='cera';
  }
    else if (lastPart.charAt(0) === '5') {
      clientName = 'warhammer';
      activeTheme = 'warhammer';
      brandColor = 'warhammer';
      seasonBrand = 'brand_blackfriday,brand_ads';
      ThemeList = 'warhammer,yellow,black,xblue,xmaroon,xblack,xgray,xpink,printer';
      SeasonList = 'brand_christmas,brand_newyear,brand_blackfriday,brand_thanks,brand_diwali,brand_ads';
      listLanguage = 'English';
      CustomFont='bitter';
  }
  }

  return (
    <div>
      <AppTheme clientName={clientName} activeTheme={activeTheme} CustomFont={CustomFont} ThemeList={ThemeList} brandColor={brandColor} listLanguage={listLanguage} seasonBrand={seasonBrand} SeasonList={SeasonList} />
    </div>
  );
}

export default NewDemo;